import "./_profile-proposal-action-menu.scss"
import {Button, Dropdown} from "../../../components";
import React, {ReactElement} from "react";

interface ProfileProposalActionMenuProps {
    readonly dropdownItems: readonly ReactElement[];
    readonly disabled?: boolean;
    readonly dataTestId?: string;
}

export function ProfileProposalActionMenu({dropdownItems, disabled = false, dataTestId}: ProfileProposalActionMenuProps) {
    const menuClassName = "profile-proposal-action-menu marginright-md";
    const actionMenu = disabled ? (
        <div className={menuClassName}>
            <Button
                aria-label="profileProposalMenu"
                data-testid={dataTestId}
                icon="only"
                iconName="menu_dots"
                kind="borderless"
                size="small"
                disabled
            />
        </div>
    ) : (
        <Dropdown
            id="profileProposalActionMenu"
            name="dropdown-grouped"
            aria-label="profileProposalMenu"
            className={menuClassName}
            alignRight={true}
            buttonAriaLabel="Menu"
            buttonIcon="only"
            buttonSize="small"
            defaultPageSize={15}
            disabled={false}
            dropUp={false}
            dropdownKind="menu"
            buttonKind="borderless"
            dynamicDropAlign={false}
            dynamicDropDirection={false}
            iconNameClose="menu_dots"
            iconNameOpen="menu_dots"
            labelWidth="100%"
            nativeOnMobile={false}
            open={false}
            panelHeight="auto"
            panelWidth={240}
            required={false}
            searchable={false}
            value={null}
            virtualScroll={false}
        >
            {dropdownItems}
        </Dropdown>
    );

    return (
        <div className={"profileProposalMenu"}>
            {actionMenu}
        </div>
    );
}